var _line, _line2, _line3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 1.5,
    x2: 26,
    y2: 1.5,
    stroke: "white",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 9.5,
    x2: 26,
    y2: 9.5,
    stroke: "white",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 17.5,
    x2: 26,
    y2: 17.5,
    stroke: "white",
    strokeWidth: 3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.2dc4cc78150799ff3d3893cf82e80a56.svg";
export { ForwardRef as ReactComponent };